import React, { useState } from 'react';
import cn from 'classnames';
import common from "../common.module.scss"
import style from "./OrderHistory.module.scss"
import { numberToFinanceFormat } from '../../../../utils';
import CloseIcon from '../../../shared/icons/CloseIcon';
import { ORDER_STATUSES_DATA } from '../../../../mock';
import BallIcon from '../../../shared/icons/BallIcon';
import LogoIcon from '../../../shared/icons/LogoIcon';
import LupeIcon from '../../../shared/icons/LupeIcon';
import UsersIcon from '../../../shared/icons/UsersIcon';
import OrdersIcon from '../../../shared/icons/OrdersIcon';
import UncheckCircleIcon from '../../../shared/icons/UncheckCircleIcon';
import OrdersInfoDirections from './OrdersInfoDirections';
import OrdersInfoCargo from './OrdersInfoCargo';
import YandexMap from './YandexMap';
import OrdersDriverInfo from './OrdersDriverInfo';
import ListDocsOrder from './ListDocsOrder';
import OrdersInfoAddressList from './OrdersInfoAddressList';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const OrderHistory = ({
    item,
    onClose,
    statusHistory,
    recipientName,
    senderName,
    cargoDetails,
    cityFrom,
    cityTo,
    routeData,
    isLoadingMap,
    routeStartCity,
    coordinateTruck,
    bookingDate,
    driverPhotos,
    listDocDriver
}) => { 
  const { user } = useSelector((state) => state);
  const { t } = useTranslation();

    const getIconColor = (status, step) => {
        const rejectedStatuses = ['rejected', 'canceled', 'rejectedloadingcargomoderation', 'rejectedunloadingcargomoderation'];
        const currentStep = {
            moderation: 1,
            awaitingpayment: 1,
            rejected: 1,
            // canceled: 1,
            published: 2,
            booked: 3,
            confirmed: 3,
            processloadingcargo: 3,
            loadingcargomoderation: 3,
            waitstarttrip: 3,
            rejectedloadingcargomoderation: 3,
            onthetrip: 4,
            processunloadingcargo: 4,
            unloadingcargomoderation: 4,
            rejectedunloadingcargomoderation: 4,
            completed: 5
        };

        if (rejectedStatuses.includes(status) && step === currentStep[status]) {
            return { backgroundColor: '#C84620', iconColor: '#FFF', IconType: 2 };
        } else if (step <= currentStep[status]) {
            return { backgroundColor: '#212121', iconColor: '#FFF', IconType: 2 };
        } else {
            return { backgroundColor: '#F0F0F0', iconColor: '#212121', IconType: 1 };
        }
    };

    const renderIcon = (step) => {
        const status = item?.status;
        const { backgroundColor, iconColor, IconType } = getIconColor(status, step);

        switch (step) {
            case 1:
                return <>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <LogoIcon type={IconType} color={iconColor} width='32px' height='32px' />
                        </div>
                    </div>

                </>
            case 2:
                return <>
                    <div className={style.history_icons_line} style={{ backgroundColor }}></div>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <LupeIcon color={iconColor} />
                        </div>
                    </div>
                </>
            case 3:
                return <>
                    <div className={style.history_icons_line} style={{ backgroundColor }}></div>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <UsersIcon color={iconColor} />
                        </div>
                    </div>
                </>
            case 4:
                return <>
                    <div className={style.history_icons_line} style={{ backgroundColor }}></div>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <OrdersIcon color={iconColor} />
                        </div>
                    </div>
                </>
            case 5:
                return <>
                    <div className={style.history_icons_line} style={{ backgroundColor }}></div>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <UncheckCircleIcon color={iconColor} />
                        </div>
                    </div>
                </>
            default:
                return null;
        }
    };

    const setSummary = (status) => {
        switch (status) {
            case 'moderation': return t('statusHints.moderation') // Проверяем все документы
            case 'published': return t('statusHints.published') // Найдем водителя в течение 6 часов
            case 'waitstarttrip': return ""
            case 'awaitingpayment': return ""
            case 'waitingforcompletion': return
            case 'inprocess': return
            case 'onthetrip': return t('statusHints.onthetrip') // Будет доставлено через 12ч. 12м.
            case 'waitloadingcargo': return t('statusHints.waitloadingcargo') // Будет доставлено через 12ч. 12м.
            case 'completed': return
            case 'rejectedunloadingcargomoderation': return
            case 'unloadingcargomoderation': return
            case 'processunloadingcargo': return t('statusHints.processunloadingcargo') // Идет разгрузка
            case 'processloadingcargo': return t('statusHints.processloadingcargo') // Идет погрузка
            case 'unloadingcargo': return
            case 'loadingcargo': return t('statusHints.loadingcargo') // Будет доставлено через 12ч. 12м.
            case 'waitcompletion': return
            case 'canceled': return
            case 'booked': return `${item?.driverSurname} ${item?.driverName}`;
            case 'rejected': return
            case 'confirmed': return

            default: return '';
        }
    };

    return (
      <div className={cn("modal-overlay", style.history_wrapper)}>
        <div className={style.history_modal}>
          <div className={style.history_topbar}>
            <div className={style.history_title}>{t ("orderInfo.orderInfoTitle")}</div>{" "}
            <CloseIcon style={{ cursor: "pointer" }} fill="#6D7885" onClick={onClose} />
          </div>
          <div className={style.history_main}>
            <div className={style.history_content}>
              <div className={style.history_status}>
                <div className={style.history_status_text}>
                  <div
                    className={style.history_status_title}
                    style={{ color: ORDER_STATUSES_DATA(t)[item?.status]?.color }}
                  >
                    <BallIcon fill={ORDER_STATUSES_DATA(t)[item?.status]?.color} />
                    {ORDER_STATUSES_DATA(t)[item?.status]?.title || item?.status}
                  </div>
                  <div className={style.history_status_summary}>
                    {setSummary(item.status)}
                  </div>
                </div>

                <div className={style.history_icons}>
                  {renderIcon(1)}
                  {renderIcon(2)}
                  {renderIcon(3)}
                  {renderIcon(4)}
                  {renderIcon(5)}
                </div>
              </div>

              <div className={style.history_details}>
                <div className={style.history_details_line}>
                  <BallIcon fill="#6D7885" />
                  <div className={style.history_details_border}></div>
                  <BallIcon fill="#6D7885" />
                </div>
                <div className={style.history_details_info}>
                  {statusHistory.map((status, index) => (
                    <div key={index} className={style.history_details_item}>
                      <div className={style.history_details_title}>
                        {status.statusName}
                      </div>
                      <div className={style.history_details_summary}>
                        {status.createdAtStr}
                        {status.moderator && <span> — {status.moderator}</span>}
                        {status.addressName && <span> — {status?.addressName}</span>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {driverPhotos && driverPhotos.length > 0 ? (
                <ListDocsOrder documents={driverPhotos} />
              ) : null}

              {item && item.addressList.length < 1 ? (
                <OrdersInfoDirections
                  item={item}
                  senderName={senderName}
                  recipientName={recipientName}
                />
              ) : (
                <OrdersInfoAddressList order={item} addressList={item?.addressList} />
              )}

              <div className={cn(common.basic_wrapper)}>
                <div className={common.basic_numbers}>
                  <span className={common.basic_price}>
                    {numberToFinanceFormat(user?.type === "Expeditor" && user?.companyId !== item?.companyId ? item?.netPrice : item?.price)}〒
                  </span>
                  <div className={common.basic_lower_part}>
                    <span className={common.basic_number}> №{item?.number}</span>
                  </div>
                </div>
                <div className={common.basic_distance}>
                  {numberToFinanceFormat(item?.distance)} {t ('analytics.distance_metric')}
                </div>
              </div>

              {item && item.driverId && (
                <OrdersDriverInfo
                  item={item}
                  driverId={item.driverId}
                  recipientName={recipientName}
                  senderName={senderName}
                  bookingDate={bookingDate}
                  listDocDriver={listDocDriver}
                />
              )}

              <OrdersInfoCargo item={cargoDetails} />
            </div>
            <div className={style.history_maps}>
              <YandexMap
                item={item}
                addressList={item?.addressList}
                cityFrom={cityFrom}
                cityTo={cityTo}
                routeData={routeData}
                isLoadingMap={isLoadingMap}
                routeStartCity={routeStartCity}
                coordinateTruck={coordinateTruck}
              />
            </div>
          </div>
        </div>
        <button className={style.history_btn}></button>
      </div>
    );
};

export default OrderHistory;